import { CONTOUR, getContour } from '@pp/axios'
import { bgLeadSlice, bgLimitRequestSlice, ClientLimitInfo, clientLimitInfoSLice } from 'Pages/ibro'
import { ChannelHandler, SocketMessage, SocketMessageTypes } from 'Modules/Socket'
import { Callback } from 'Src/types/utilTypes'

export class BgLimitRequestChannel implements ChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}

	public work(data: SocketMessage): void {
		const { message } = data
		// eslint-disable-next-line no-console
		if (getContour() === CONTOUR.DEV || getContour() === CONTOUR.UAT) console.log('ws', message)
		const request_type = message?.type as SocketMessageTypes
		const id = message?.payload?.request_id
		const status = message?.payload?.success
		// eslint-disable-next-line
		const errors = message?.payload?.errors

		if (
			(request_type === SocketMessageTypes.CHECK_LIMIT ||
				(request_type === SocketMessageTypes.POST_LIMIT_REQUEST && errors) ||
				request_type === SocketMessageTypes.UPDATE_LIMIT_REQUEST ||
				request_type === SocketMessageTypes.CURRENT_ELEMENTS) &&
			id
		) {
			this.dispatch(
				bgLimitRequestSlice.actions.updateLimitRequestStatus({ id, status, request_type, errors })
			)
		}

		if (request_type === SocketMessageTypes.CHECK_STATUS && id) {
			const { changes } = message.payload
			this.dispatch(
				bgLimitRequestSlice.actions.updateLimitRequestStatus({
					id,
					status,
					request_type,
					changes,
					errors,
				})
			)
		}

		if (request_type === SocketMessageTypes.LEAD_COMPLETE && id) {
			const { shortname, purchasecode, inn, request_type } = message.payload
			this.dispatch(
				bgLeadSlice.actions.leadCompleteBg({
					id,
					status,
					info: { shortname, purchasecode, inn },
					requestType: request_type,
				})
			)
		}

		if (request_type === SocketMessageTypes.GET_CLIENT_LIMIT) {
			const res = status ? (message?.payload?.result as ClientLimitInfo) : null
			this.dispatch(clientLimitInfoSLice.actions.handleClientLimitMessage(res))
		}
	}
}
